import { Helmet } from 'react-helmet-async';

interface OpenGraphProps {
  title: string;
  description: string;
  url: string;
  image: string;
  type?: 'website' | 'article';
  siteName?: string;
  locale?: string;
  // Article-specific props
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
  tags?: string[];
}

/**
 * Componente para renderizar Open Graph tags
 * 
 * Otimiza compartilhamento em redes sociais (Facebook, LinkedIn, WhatsApp, etc)
 * 
 * @see https://ogp.me/
 */
export function OpenGraph({
  title,
  description,
  url,
  image,
  type = 'website',
  siteName = 'Johnny Vaz',
  locale = 'pt_BR',
  publishedTime,
  modifiedTime,
  author,
  section,
  tags,
}: OpenGraphProps) {
  return (
    <Helmet>
      {/* Basic Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />

      {/* Article-specific Open Graph */}
      {type === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {type === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      {type === 'article' && section && (
        <meta property="article:section" content={section} />
      )}
      {type === 'article' && tags && tags.map((tag, index) => (
        <meta key={index} property="article:tag" content={tag} />
      ))}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@johnnyvaz" />
      <meta name="twitter:creator" content="@johnnyvaz" />
    </Helmet>
  );
}
